import { render, staticRenderFns } from "./SetupReturn.vue?vue&type=template&id=cfc1a9ee&"
import script from "./SetupReturn.vue?vue&type=script&lang=js&"
export * from "./SetupReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports